import React from 'react';
import { FormattedMessage } from 'react-intl';
import DataCenter from '@/modules/data/DataCenter';
import { useTranslation } from '@/hooks';
import { Product } from '@/type';
import { CarouselView } from '@/modules/base';

type DiscountComponentProps = {
  products: Product[];
};

export const DiscountComponent = ({ products }: DiscountComponentProps) => {
  const { language } = useTranslation();
  const description_de =
    'Jedes Essen wird im Morgengrauen von Hand hergestellt, wobei nur das einfachste verwendet wird Zutaten, ' +
    'um Gerüche und Aromen hervorzuheben, die den ganzen Block ansprechen. Schauen Sie jederzeit vorbei und erleben Sie die ' +
    'Einfachheit am feinsten.';
  const description_en =
    'Each food is handmade at the crack of dawn, using only the simplest of ingredients to bring out ' +
    'smells and flavors that beckon the whole block. Stop by anytime and experience simplicity at its finest.';
  const description_zn =
    '每种食物都是在破晓时分手工制作的，仅使用最简单的配料制成，散发着整个街区气息的香气和风味。随时停下来，享受最好的简单体验。';

  const setDescription = (language?: string) => {
    switch (language) {
      case DataCenter.SUPPORT_LANGUAGE.en.language:
        return description_en;
      case DataCenter.SUPPORT_LANGUAGE.zh.language:
        return description_zn;
      default:
        return description_de;
    }
  };

  const displayProducts = products.length > 4 ? products.slice(0, 4) : products;

  return (
    <section id="discount" className="description_content">
      <div className="text-content container">
        <div className="col-md-6">
          <h1>
            <FormattedMessage id="app.speciality.title" />
          </h1>
          <div className="icon-hotdog fa-2x" />
          <p className="desc-text">{setDescription(language)}</p>
        </div>
        <div className="col-md-6">
          <CarouselView
            items={displayProducts}
            itemVew={(product) => (
              <img
                src={product.document?.path}
                alt={product.document?.file_name}
              />
            )}
          />
        </div>
      </div>
    </section>
  );
};
